import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import RoleUtils from '../utils/roleUtils.js';
import ServiceCalls from '../utils/serviceCalls.js';
import '../styles/Avatar.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRectangleList} from '@fortawesome/free-solid-svg-icons';
import { refreshWorklistPage } from '../pages/VendorWorklist';
export default class WorklistIndicator extends Component {
    constructor(props) {
        super(props);
        this.getRequestNotifications = this.getRequestNotifications.bind(this);
        this.state = {
            isLoading: true,
            notifications: [],
            pid: 0,
            hasAccess: RoleUtils.canAccess(props.currentUser, props.currentCompanyId, RoleUtils.worklistPageAccessRoles())  // DE1001911 Change to PageAccessRoles to allow Optum Admins to view
        }
    }

    componentDidMount() {
        this.getRequestNotifications();
        setInterval(() => {
            this.getRequestNotifications();
        }, 20 * 1000);
       
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.currentCompanyId !== this.props.currentCompanyId) {
            this.setState({
                isLoading: true,
                notifications: [],
                pid: 0,
                hasAccess: RoleUtils.canAccess(this.props.currentUser, this.props.currentCompanyId, RoleUtils.worklistPageAccessRoles())  // DE1001911 Change to PageAccessRoles to allow Optum Admins to view
            });

            this.getRequestNotifications();
        }
    }
  
    getRequestNotifications() {
        if (this.state.hasAccess) {
            console.log(`Calling Get Request Notifications`);
            ServiceCalls.getBankRequestNotifications(this.props.currentCompanyId).then(function (results) {
                if (results) {
                    this.setState({
                        isLoading: false,
                        notifications:results
                    });
                }
                else {
                    this.setState({
                        isLoading: false,
                        notifications: false
                    });
                }
            }.bind(this));
        }
        else {
            console.log(`No access to worklist.`);
            this.setState({
                isLoading: false
            });
        }
    }


    render() {
        const { isLoading, hasAccess, notifications } = this.state;
    
        if (isLoading) {
            return (<div> - </div>);
        }
        else if (hasAccess) {
            return (
                <Link to="/Worklist" title="View Worklist" reloadDocument={true }>
                    <button title="Worklist" className="avatar-masthead-button">
                        {(notifications.length > 0)
                            ? <span id="notificationInd" className="fa-layers fa-3x fa-fw">
                                <FontAwesomeIcon id="font-awesome-notif-worklist" icon={faRectangleList} />  
                                <span id="inboxCounter" className="fa-layers-counter" data-fa-transform="shrink-11 down-4.2 left-7">{notifications.length}</span>                               
                               </span>
                            : <FontAwesomeIcon id="font-awesome-worklist" size="4x" icon={faRectangleList} />                                
                            
                       }
                    </button>
                </Link>
            );
        }
        else {
            return (<></>);
        }
    }
}